// Base
import Image from 'next/image'
import Link from 'next/link'

// Components
import { Container, Box, Flex, Text, Button } from 'yard-utilities/components'

// Images
import Background from '@images/v25/backgrounds/homepage/background.png'

// Styles
import styles from './HomepageWrapper.module.sass'

// Data
import data from '@data/v25/es/ft1/media.json'

interface HomepageWrapperProps {
  redirectURL?: string
}

const HomepageWrapper = ({
  redirectURL = '/v25/es/membership'
}: HomepageWrapperProps) => {
  return (
    <section className={styles.section}>
      <div className={styles.imageWrapper}>
        <Image
          src={Background}
          fill
          sizes="(min-width: 1120px) 3000px, 800px"
          placeholder="blur"
          priority
          alt="Sandy Beach"
        />
      </div>

      <Container>
        <Box padding={{ sm: [48, 0, 24] }} className={styles.wrapper}>
          <Box spacing={{ sm: 48 }}>
            <Text
              tagName="h1"
              variant="title-1"
              align="center"
              textColor="white"
              spacing={{ sm: 16 }}
              transform="capitalize"
              className={styles.title}
            >
              Las mejores ofertas de vuelos entregadas automáticamente
            </Text>
            <Text
              tagName="p"
              variant="body-2"
              align="center"
              textColor="white"
              spacing={{ sm: 48 }}
              className={styles.description}
            >
              Directamente a tu bandeja de entrada
            </Text>

            <Flex fullWidth justifyContent="center">
              <Button href={redirectURL} variant="yellow-sm" as={Link}>
                registrarse
              </Button>
            </Flex>
          </Box>

          <Flex
            rowGap={{ sm: 24 }}
            columnGap={{ sm: 32 }}
            wrap
            justifyContent="center"
            alignItems="center"
            // id="recent-deals-anchor"
          >
            {data.map((item) => (
              <Image
                key={item.id}
                src={item.img}
                height={32}
                width={item.width}
                alt={item.alt}
              />
            ))}
          </Flex>
        </Box>
      </Container>

      <div id="recent-deals-anchor" />
    </section>
  )
}

export default HomepageWrapper
